<template>
    <div class="appMenu">
        <div class="appsIcon"
            tabindex="0"
            @click="isVisible=!isVisible">
            <Icon :class="[{ active: isVisible}]"
                icon="menu"/>
        </div>
        <TransitionEffect name="slideUp">
            <Menu
                v-if="isVisible"
                @close="isVisible=false"
                v-on-clickaway="closeOverlay"/>
        </TransitionEffect>
    </div>
</template>

<script>
    import Menu from '@/components/layout/header/Menu'

    import { mixin as clickaway } from 'vue-clickaway'

    export default {
        name: 'GlobalMenu',
        mixins: [ clickaway ],
        components: {
            Menu
        },
        data() {
            return {
                isVisible: false,
            }
        },
        methods: {
            closeOverlay() {
                this.isVisible = false
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.isVisible = false
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .active.dark {
        color: var(--color-primary-500);

        &:hover {
            color: var(--color-primary-500);
        }
    }

    .appsIcon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: center;
        padding: 0.75rem;
        border-radius: 1rem;
        transition: $transition-eio-20;
        z-index: 1;

        &:hover {
            background: var(--color-white-40);
        }

        &:focus {
            box-shadow: var(--shadow-focus-s);
            outline: 0;
        }
    }
    
    @media all and (max-width: 1200px) {
        .appsIcon {
            &:hover {
                background: none;
            }

            &:focus {
                box-shadow: none;
            }
        }
    }

    @media all and (max-width: 560px) {
        .appMenu {
            display: flex;
            justify-content: center;
            flex: 1;
        }
    }
</style>